import React, { Component } from 'react'
import NumberFormat from 'react-number-format'
import Autosuggest from 'react-autosuggest';
import axios from 'axios'
import { APIURL } from '../../config/config'

const suggestionHighlightedDivStyle = { backgroundColor: '#5bc0de' };
const suggestionDivStyle = { padding: '10px'};

const unitList = [
  { id: 'ชุด',    name: 'ชุด' },
  { id: 'ชิ้น',    name: 'ชิ้น' },
  { id: 'กล่อง',  name: 'กล่อง' },
  { id: 'โหล',   name: 'โหล' },
  { id: 'เครื่อง', name: 'เครื่อง' },
  { id: 'ถัง',    name: 'ถัง' },
  { id: 'ขวด',   name: 'ขวด' },
  { id: 'ลูก',    name: 'ลูก' },
  { id: 'คู่',     name: 'คู่' },
]

const getSuggestions = value => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0 ? [] : unitList.filter(lang =>
    lang.name.toLowerCase().slice(0, inputLength) === inputValue
  );
};

// When suggestion is clicked, Autosuggest needs to populate the input
const getSuggestionValue = suggestion => suggestion.name;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <span>
    {suggestion.name}
  </span>
);

class SparePartList extends Component {

  constructor (props){
    super(props)
    this.state = {
      actionType: 'บันทึก',
      suggestions: [],
      id: '',
      name: '',
      price: 0,
      quantity: 0,
      unit: '',
      sparePartList: [],
    }
    this.onSparePartSubmit = this.onSparePartSubmit.bind(this)
    this.loadSparePart = this.loadSparePart.bind(this)
    this.onDeleteSparePart= this.onDeleteSparePart.bind(this)
    this.onPreUpdateSparePart= this.onPreUpdateSparePart.bind(this)
    this.resetFormState= this.resetFormState.bind(this)

    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    this.loadSparePart();
  }

  componentWillReceiveProps(nextProps){
      if(nextProps.reloadSparePart !== this.props.reloadSparePart){
        if(nextProps.reloadSparePart){
          this.loadSparePart();
        }
      }
  }

  handleChange(event) {
    let name  = event.target.name;
    let value = event.target.value;
    if(name === 'name'){
      this.setState({name: value})
    }else if(name === 'price'){
      this.setState({price: value})
    }
  }

  loadSparePart() {
    axios.get(APIURL+'/spare_part').then(res => {
      if(res.status === 200) {
        this.setState({
          sparePartList: res.data
        },()=>{
          if(this.props.reloadSparePart){
            this.props.onReloadSparePartFinish();
          }
        });
      }
    })
  }
  // Autosuggest will call this function every time you need to update suggestions.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value)
    });
  };
  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onChange = (event, { newValue }) => {
    this.setState({
      unit: newValue
    });
  };

  onSparePartSubmit(e){
    e.preventDefault()
    let name = e.target.name.value
    let price = e.target.price.value
    let quantity = e.target.quantity.value
    let unit = e.target.unit.value
    let user = this.props.user.user

    if(name===''){
      alert('กรุณากรอกชื่ออะไหล่/วัสดุอุปกรณ์');
      return;
    }

    let data = {
      name: name,
      price: price,
      quantity: quantity,
      unit: unit,
      type: 'warehourse',
      user: user
    }

    e.target.name.value = ''
    e.target.price.value = ''
    e.target.quantity.value = ''
    e.target.unit.value = ''
    this.setState({
      price: 0,
      quantity: 0,
      unit: ''
    })
    // add
    if(this.state.actionType === 'บันทึก'){
      axios.post(APIURL+'/spare_part', data)
        .then(res => {
          if(res.status === 200){
            this.loadSparePart();
          }
        })
        .catch(err => {
          console.log(err)
        })
    }else if(this.state.actionType === 'แก้ไข'){
      //edit
        let id = e.target.id.value
        axios.put(APIURL+'/spare_part/'+id, data)
        .then(res => {
          if(res.status === 200){
            this.loadSparePart();
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

  onDeleteSparePart(sparePart){
    let id = sparePart.id
    axios.delete(APIURL+'/spare_part/'+id)
      .then(res => {
        if(res.data.delete){
          alert('ลบเรียบร้อยแล้ว')
          this.resetFormState()
          this.loadSparePart()
        }else{
          alert(res.data.message);
        }
      })
  }

  onPreUpdateSparePart(sparePart) {
    // let id = sparePart.id
    this.setState({
      actionType: 'แก้ไข',
      id: sparePart.id,
      name: sparePart.name,
      price: sparePart.price,
      unit: sparePart.unit,
    });
  }

  resetFormState(){
    this.setState({
      actionType: 'บันทึก',
      id: '',
      name: '',
      price: 0,
      quantity: 0,
      unit: '',
    });
  }

  render() {
    const inputProps = {
      placeholder: 'ชื่อหน่วย',
      value: this.state.unit ,
      onChange: this.onChange ,
      type: 'search',
    };

    var sparePartList = this.state.sparePartList.map((sparePart, index) => {
      return (
        <tr key={index+1}>
          <td>{index+1}</td>
          <td>{sparePart.name}</td>
          <td>
            <NumberFormat
              displayType={'text'}
              thousandSeparator={true}
              value={sparePart.price}/>
          </td>
          <td className="text-center">{sparePart.quantity_in}</td>
          <td>{sparePart.unit}</td>
          <td>
            <button
              className="btn btn-sm btn-danger btn-md-width"
              onClick={()=>this.onDeleteSparePart(sparePart)}
            >
              <i className="fa fa-remove"></i> ลบ
            </button>
            <button
              className="btn btn-sm btn-warning btn-md-width"
              onClick={()=>this.onPreUpdateSparePart(sparePart)}
            >
              <i className="fa fa-edit"></i> แก้ไข
            </button>
          </td>
        </tr>
      )
    })

    return (
      <div className="row">
        <div className="col-lg-8">
          <div className="card card-accent-info">
            <div className="card-header">
              <strong>รายการอะไหล่</strong>
            </div>
            <div className="card-block">
              <table className="table table-striped">
                <thead>
                <tr>
                  <td>#</td>
                  <td>ชื่ออะไหล่รถ</td>
                  <td>ราคา</td>
                  <td className="text-center">จำนวน</td>
                  <td>หน่วย</td>
                  <td>&nbsp;</td>
                </tr>
                </thead>
                <tbody>
                {sparePartList}
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <div className={ this.state.actionType==="แก้ไข"? "card card-accent-warning" :"card card-accent-danger"}>
            <form action="" method="post" onSubmit={this.onSparePartSubmit}>
              <div className="card-header">
                <strong>{this.state.actionType==="แก้ไข"? "แก้ไข" : "เพิ่ม" }รายการอะไหล่</strong>
              </div>
              <div className="card-block">
                <div className="form-group">
                  <label htmlFor="name">ชื่ออะไหล่/วัสดุอุปกรณ์ </label>
                  <input name="name"
                         type="text"
                         className="form-control"
                         placeholder="ชื่ออะไหล่/วัสดุอุปกรณ์ "
                         value={this.state.name}
                         onChange={this.handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="name">ราคาต่อหน่วย </label>
                  <input name="price"
                         type="text"
                         className="form-control hidden"
                         placeholder="ราคาต่อหน่วย "
                         value={this.state.price}
                         onChange={this.handleChange}
                  />
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    prefix={'฿'}
                    placeholder="ราคาต่อหน่วย"
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    value={this.state.price}
                    onValueChange = {(values) => {
                      const {value} = values;
                      this.setState({price: value})
                    }}
                  />
                </div>
                <div className={this.state.actionType==='แก้ไข'? "hidden" : "form-group" }>
                  <label htmlFor="name">จำนวนเริ่มต้น </label>
                  <input name="quantity"
                         type="text"
                         className="form-control hidden"
                         placeholder="จำนวนเริ่มต้น "
                         value={this.state.quantity}
                         onChange={this.handleChange}
                  />
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    prefix={'฿'}
                    placeholder="จำนวนเริ่มต้น"
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    value={this.state.quantity}
                    onValueChange = {(values) => {
                      const {value} = values;
                      this.setState({quantity: value})
                    }}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="center_name">หน่วย</label>
                  <input type="text"
                         className="form-control hidden"
                         value={this.state.unit}
                         name="unit"
                         placeholder="hidden"
                         onChange={this.handleChange}
                  />
                  <Autosuggest
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps}
                    theme={{
                      input: 'form-control',
                      suggestion: suggestionDivStyle,
                      suggestionsList: 'list-unstyled ',
                      suggestionHighlighted: suggestionHighlightedDivStyle
                    }}

                  />
                </div>

              </div>
              <div className="card-footer text-right">
                <button type="reset"
                        className="btn btn-sm btn-danger"
                        onClick={this.resetFormState}
                >
                  <i className="fa fa-refresh"></i> ยกเลิก
                </button>
                <button type="submit"
                        className={this.state.actionType==="แก้ไข"? "btn btn-sm btn-warning" :"btn btn-sm btn-primary"}
                >
                  <i className={this.state.actionType==="แก้ไข"? "fa fa-edit":"fa fa-save"}></i>
                  &nbsp;{this.state.actionType}
                </button>

                <input type="hidden" name="id" value={this.state.id}/>

              </div>
            </form>
          </div>
        </div>

      </div>
    )
  }
}




export default SparePartList